// extracted by mini-css-extract-plugin
export default {"main-div":"Faculty_main-div__QZ8z-","filters-wrapper":"Faculty_filters-wrapper__SEjN8","extraInputBox":"Faculty_extraInputBox__yzk5B"};